import { gql } from '@apollo/client'

export const APPOINTMENT_AVAILABILITY = gql`
  query AppointmentAvailability(
    $locationId: ID!
    $startDateUtc: Date!
    $endDateUtc: Date!
  ) {
    pmsAvailableAppointments(
      locationId: $locationId
      startDateUtc: $startDateUtc
      endDateUtc: $endDateUtc
    ) {
      __typename
      ... on PmsAvailableAppointments {
        appointmentTypeAvailability {
          id
          name
          availableCount
        }
        appointments {
          appointmentType {
            id
            name
          }
          availabilitySlotId
          date
          startTime
          endTime
          timezoneAbbr
          providerName
        }
      }
      ... on VendorServiceUnavailable {
        message
      }
      ... on InvalidStartDate {
        message
      }
    }
  }
`
